import { all } from 'redux-saga/effects'
import regionSaga from './region'
import signupSaga from './signup'
import freeSignupSaga from './freeSignup'
import 'regenerator-runtime/runtime'

export default function* root() {
  yield all([regionSaga(),signupSaga(),freeSignupSaga()])
}
